/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Date: 12/14/20
 * Copyright All Rights Reserved
 */
// @flow

import React from 'react';
import { Link } from 'react-router-dom';

const LinkCell = (url: string) => (data: Object) => {
  const { uuid, firstName } = data.original;
  return (
    <Link id={uuid} to={{ pathname: `${url}/${uuid}` }}>
      {firstName}
    </Link>
  );
};

export default LinkCell;



// WEBPACK FOOTER //
// ./js/components/pages/Admin/sections/Users/ViewUsers/ViewUsersTable/LinkCell/index.jsx